import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { FlexibleCalculationTemplatesListPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/FlexibleCalculationTemplatesListPage';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute('/_authenticated/next/templates/flexible-calculation/')({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

// An unknown `/templates/flexible-calculation/...` reaches `NotFoundPage`, not blank templates chrome.
function RouteComponent(): JSX.Element {
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <FlexibleCalculationTemplatesListPage />
        </SidebarPageContent>
    );
}
